import { TwoStepLogin } from './TwoStepLogin.js';
export default TwoStepLogin;
//# sourceMappingURL=index.js.map